import { api } from './client'

/** The reference stored in a "file" custom-field value. */
export interface FileRef {
  key: string
  filename: string
  size: number
  contentType: string | null
}

/** Upload a file (proxied to S3 by the backend) and get its stored reference. */
export async function uploadFile(file: File): Promise<FileRef> {
  const form = new FormData()
  form.append('file', file)
  // The api instance defaults Content-Type to application/json; null removes it for this request
  // so the browser sets multipart/form-data with the boundary (else the backend sees no multipart).
  const { data } = await api.post<FileRef>('/api/files', form, {
    headers: { 'Content-Type': null },
  })
  return data
}

/** A short-lived presigned URL to download a stored file. */
export async function fileDownloadUrl(key: string): Promise<string> {
  const { data } = await api.get<{ url: string }>('/api/files/url', { params: { key } })
  return data.url
}

/** True when a custom value is a file reference (vs. a plain scalar). */
export function isFileRef(value: unknown): value is FileRef {
  return !!value && typeof value === 'object' && 'key' in (value as Record<string, unknown>)
}
